export default __webpack_public_path__ + "static/media/arrowLeft.78059af2.svg";